/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Lifecycle_Deleted_ToastInputs */

const en_lifecycle_deleted_toast = /** @type {(inputs: Lifecycle_Deleted_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} deleted`)
};

const de_lifecycle_deleted_toast = /** @type {(inputs: Lifecycle_Deleted_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} gelöscht`)
};

/**
* | output |
* | --- |
* | "{name} deleted" |
*
* @param {Lifecycle_Deleted_ToastInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const lifecycle_deleted_toast = /** @type {((inputs: Lifecycle_Deleted_ToastInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lifecycle_Deleted_ToastInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_lifecycle_deleted_toast(inputs)
	return en_lifecycle_deleted_toast(inputs)
});